















































































import { Component, Vue } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";
import FileManager from "@/components/files/FileManager.vue";
import {
  ErrorResponse as IErrorResponse,
  FileItem as IFileItem,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import { importCsvApi } from "@/getinfo-api";
import { AxiosError } from "axios";
import { CsvImport as ICsvImport } from "@/api-v2/import-export/models/csv-import";
import CBlock from "@/components/form/CustomPage/CBlock.vue";

@Component({ components: { CBlock, CustomButton, FileManager } })
export default class ImportContractors extends Vue {
  errors!: any;
  delimiter?: string;
  popupIsOpen: boolean = false;
  isSavingProcess: boolean = false;
  csvForContractors!: IFileItem;
  data() {
    return {
      csvForContractors: undefined,
      delimiter: ";",
      errors: undefined
    };
  }

  ImportContracts() {
    if (this.csvForContractors) {
      this.isSavingProcess = true;
      const body: ICsvImport = {
        delimeter: this.delimiter,
        fileId: this.csvForContractors.id
      };
      importCsvApi.Contractor.importContractorCsv(this.selectedCompany.id, body)
        .then(res => {
          this.$store.dispatch("successToast", {
            message: `${this.$tc(this.$translate.Successful)}`
          });
          this.$router.push({
            name: "ImportView",
            params: { id: res.data.id }
          });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          if (err?.response) {
            const serverError = err.response?.data?.message;
            const validateError: any = err.response.data;

            if (serverError) {
              this.errors = serverError;
            }

            if (validateError) {
              this.errors = validateError
                ?.map((_: any) => `${_.line}: ${_.message}`)
                .join(", ");
            }

            this.$bvToast.toast(`${this.errors}`, {
              variant: "danger",
              title: `${this.$tc(this.$translate.Error)}`
            });
          } else {
            this.$bvToast.toast(
              `${this.$tc(this.$translate.SorrySomethingWentWrong)}`,
              {
                variant: "danger",
                title: `${this.$tc(this.$translate.Error)}`
              }
            );
          }
        })
        .finally(() => {
          this.isSavingProcess = false;
        });
    } else {
      this.$bvToast.toast(`${this.$tc(this.$translate.FileNotSelected)}`, {
        variant: "danger",
        title: `${this.$tc(this.$translate.Error)}`
      });
    }
  }

  getFileForImportContractors(file: IFileItem) {
    this.csvForContractors = file;
    this.popupIsOpen = false;

    if (file.mimeType !== "text/csv") {
      this.$bvToast.toast(`${this.$tc(this.$translate.YouCanOnlyUseScvFile)}`, {
        variant: "danger",
        title: `${this.$tc(this.$translate.Error)}`
      });
      //@ts-ignore
      this.csvForContractors = {};
    }
  }

  openFileManager() {
    this.popupIsOpen = !this.popupIsOpen;
  }

  get selectedCompany() {
    return this.$store.getters.selectedCompany;
  }
}
